import { gql } from '__generated__';

const HideExportProfileMutation = gql(`
  mutation HideExportProfile($id: ID!) {
    hideExportProfile(id: $id)
  }
`);

export default HideExportProfileMutation;
